import axios from '@/axios/axios'

export default {
  namespaced: true,
  actions:{
    requestVerifyNumber(context, payload){
      return axios
      .post('/api/sms/send', {
        phoneNumber: payload.phoneNumber,
        type: 'VERIFY',
        contents: payload.contents
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error.response.data)
        return Promise.reject(error)
      })
    },
    confirmVerifyNumber(context, payload){
      return axios
      .post('/api/sms/confirmVerifyNumber', {
        phoneNumber: payload.phoneNumber,
        verifyNum: payload.verifyNum
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error.response.data)
        return Promise.reject(error)
      }) 
    }
  }
}